
const TOTAL_PAID = "Total Paid";
const TOTAL_VALUE = "Total Value";
const TOTAL_OWED = "Total Owed";
const QUANTITY = "Quantity";
const SHIPPING_COST = "Shipping Cost";
const SHIPPING_COST_EACH = "Shipping Cost Each";
const LANDED_COST = "Landed Cost";
const LANDED_COST_FORECAST = "Forecasted Landed";

exports.TOTAL_PAID = TOTAL_PAID;
exports.TOTAL_VALUE = TOTAL_VALUE;
exports.TOTAL_OWED = TOTAL_OWED;
exports.QUANTITY = QUANTITY;
exports.SHIPPING_COST = SHIPPING_COST;
exports.SHIPPING_COST_EACH = SHIPPING_COST_EACH;
exports.LANDED_COST = LANDED_COST;
exports.LANDED_COST_FORECAST = LANDED_COST_FORECAST;